async function changeVariantIds() {
  try {
    const productForm = document.querySelector("[data-main-product-form] form");
    const mainVariantIdInput = productForm.querySelector("[name='id']");
    const relatedProductsSliders = document.querySelectorAll(".related-products-preview");
    relatedProductsSliders.forEach((slider, index) => {
      if (slider.querySelectorAll(".swiper-slide").length < 1) {
        mainVariantIdInput.removeAttribute("disabled");
        return;
      }
      mainVariantIdInput.setAttribute("disabled", true);
      const activeSlider = slider?.querySelector(".swiper-slide.active.active_slide");
      const variantId = activeSlider?.getAttribute("data-variant");
      const variantIdInput = productForm?.querySelector(`[name='items[${index}][id]']`);
      if (variantIdInput) {
        variantIdInput.value = variantId;
      } else {
        productForm.insertAdjacentHTML(
          "beforeend",
          `<input type="hidden" name="items[${index}][id]" class="product-variant-id" value="${variantId}">`
        );
      }
    });
  } catch (error) {
    console.log("Error changing variant ids", error);
  }
}
